export const faqs = [
  {
    q: "51网址导航里的站点是根据什么收录的？",
    a: "我们更看重“用得上”而不是“名气大”。每个分类都会优先收录打开快、无强制跳转、信息说明清楚的站点，再由人工逐条核对后放进列表。",
  },
  {
    q: "为什么有的分类站点很多，有的却很少？",
    a: "分类的收录数量取决于该方向值得推荐的好站有多少。宁可少而精，也不硬凑数量，所以你会看到学习资源比电商分类更容易攒出长列表。",
  },
  {
    q: "想让自己的网站出现在导航列表里，需要怎么做？",
    a: "在“收录申请”板块点提交入口，说明站点的分类、用途和一句话简介即可。我们会先实际打开体验再决定是否收录，全程不收取费用。",
  },
  {
    q: "发现列表里的站点打不开或内容变味了怎么办？",
    a: "每个条目都可以旁敲一下反馈入口。我们会定期巡检，遇到失效或改得面目全非的站点会直接下架，保证列表里留下的都是还能用的入口。",
  },
  {
    q: "导航里的下载入口是官方渠道吗？",
    a: "我们只挂官方或明确来源的下载链接，并在条目上标注平台与版本信息。安装前建议仍以官网核对为准，遇到可疑文件请及时反馈。",
  },
];